import { render } from "./AlertaForm.vue?vue&type=template&id=0e7a24ef&scoped=true"
import script from "./AlertaForm.vue?vue&type=script&lang=js"
export * from "./AlertaForm.vue?vue&type=script&lang=js"

import "./AlertaForm.vue?vue&type=style&index=0&id=0e7a24ef&scoped=true&lang=css"
import "./AlertaForm.vue?vue&type=style&index=1&id=0e7a24ef&lang=css"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0e7a24ef"]])

export default __exports__